import { render, staticRenderFns } from "./WorkDetailModal.vue?vue&type=template&id=6eae3c83&"
import script from "./WorkDetailModal.vue?vue&type=script&lang=js&"
export * from "./WorkDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./WorkDetailModal.vue?vue&type=style&index=0&id=6eae3c83&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports